import React, { useState, useEffect } from 'react';
import { Table } from 'react-bootstrap';
import { App } from '../../interface'; 
import { removeCharacter } from '../../util/chunk';
interface SortConfig {
  key: keyof App | null;
  direction: 'asc' | 'desc';
}

interface SortableTableProps {
  data: App[];
  openApp: (link: string,link2?:string | null) => void;
}

const SortableTable: React.FC<SortableTableProps> = ({ data, openApp }) => {
  const [filteredData, setFilteredData] = useState<App[]>([]);
  const [sortConfig, setSortConfig] = useState<SortConfig>({
    key: 'app_name', // Clave inicial para ordenar
    direction: 'asc', // Dirección inicial
  });

  // Función para ordenar los datos
  const sortData = (key: keyof App, direction: 'asc' | 'desc' = 'asc') => {
    const sortedData = [...filteredData].sort((a, b) => {
      const valueA = a[key] ?? '';
      const valueB = b[key] ?? '';

      if (valueA < valueB) return direction === 'asc' ? -1 : 1;
      if (valueA > valueB) return direction === 'asc' ? 1 : -1;
      return 0;
    });

    setSortConfig({ key, direction });
    setFilteredData(sortedData);
  };

  // Actualiza los datos y aplica el orden inicial cuando `data` cambia
  useEffect(() => {
    setFilteredData(data);
  }, [data]);

  // Ordena los datos una vez que `filteredData` tiene contenido
  useEffect(() => {
    if (filteredData.length > 0 && sortConfig.key) {
      sortData(sortConfig.key, sortConfig.direction);
    }
  }, [filteredData, sortConfig.key, sortConfig.direction]);

  return (
    <Table striped bordered hover responsive className="mt-2">
      <thead>
        <tr>
          <th
            className="ps-5 pb-3 cursor-pointer"
            onClick={() => sortData('app_name', sortConfig.key === 'app_name' && sortConfig.direction === 'asc' ? 'desc' : 'asc')}
          >
            Title {sortConfig.key === 'app_name' && (sortConfig.direction === 'asc' ? '▲' : '▼')}
          </th>
          <th
            className="pb-3 cursor-pointer"
            onClick={() => sortData('location', sortConfig.key === 'location' && sortConfig.direction === 'asc' ? 'desc' : 'asc')}
          >
            App location {sortConfig.key === 'location' && (sortConfig.direction === 'asc' ? '▲' : '▼')}
          </th>
        </tr>
      </thead>
      <tbody>
        {filteredData.length > 0 &&
          filteredData.map((item, index) => (
            <tr key={index}>
              <td
                className="ps-5 cursor-pointer"
                onClick={() => openApp(item.selected_link || '', item.oktaAppLink)}
              >
                {item.app_name}
              </td>
              <td>{removeCharacter(item.location,"_")}</td>
            </tr>
          ))}
      </tbody>
    </Table>
  );
};

export default SortableTable;
